import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { API } from '../utils/api';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(3),
    textAlign: 'center'
  },
  title: {
    marginBottom: theme.spacing(2),
    fontWeight: 400
  },
  messageContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  link: {
    display: 'inline-flex',
    alignItems: 'center',
    marginLeft: theme.spacing(1),
    '& .MuiSvgIcon-root': {
      fontSize: 16,
      marginLeft: theme.spacing(0.5)
    }
  }
}));

const ConfigureSettings = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Typography variant="h4" className={classes.title}>
        Configure Settings
      </Typography>
      <Box className={classes.messageContainer}>
        <Typography component="span">
          No companies found, Click here to create company
        </Typography>
        <Link
          href={API.USER.crrUserAbout}
          color="primary"
          className={classes.link}
          underline="hover"
        >
          User Management
          <OpenInNewIcon />
        </Link>
      </Box>
    </div>
  );
};

export default ConfigureSettings;